import { useState, useCallback } from 'react'
import LoginScreen from './components/LoginScreen'
import ModeSelector from './components/ModeSelector'
import PresenterView from './components/PresenterView'
import AudienceView from './components/AudienceView'
import './App.css'
import './components/Components.css'

type AppState = 'login' | 'mode-select' | 'presenter' | 'audience'

interface ModeOptions {
  captureType?: 'microphone' | 'browser'
  sourceLang?: string
  targetLang?: string
}

function App() {
  const [appState, setAppState] = useState<AppState>('login')
  const [token, setToken] = useState<string>('')
  const [error, setError] = useState<string>('')
  const [modeOptions, setModeOptions] = useState<ModeOptions>({})

  const handleLogin = useCallback((newToken: string) => {
    setToken(newToken)
    setAppState('mode-select')
    setError('')
  }, [])

  const handleSelectMode = useCallback((mode: 'presenter' | 'audience', options?: ModeOptions) => {
    setModeOptions(options || {})
    setAppState(mode)
  }, [])

  const handleBack = useCallback(() => {
    setAppState('mode-select')
  }, [])

  const handleLogout = useCallback(() => {
    setToken('')
    setAppState('login')
  }, [])

  return (
    <div className="app">
      {appState === 'login' && (
        <LoginScreen onLogin={handleLogin} error={error} />
      )}
      
      {appState === 'mode-select' && (
        <ModeSelector onSelectMode={handleSelectMode} onLogout={handleLogout} />
      )}
      
      {appState === 'presenter' && (
        <PresenterView 
          token={token} 
          onBack={handleBack} 
          captureType={modeOptions.captureType || 'microphone'}
          sourceLang={modeOptions.sourceLang || 'vi'}
          targetLang={modeOptions.targetLang || 'en'}
        />
      )}
      
      {appState === 'audience' && (
        <AudienceView 
          token={token} 
          onBack={handleBack}
          sourceLang={modeOptions.sourceLang || 'vi'}
          targetLang={modeOptions.targetLang || 'en'}
        />
      )}
    </div>
  )
}

export default App
